import { Slot } from "@radix-ui/react-slot";
import { ComponentPropsWithRef, MouseEventHandler, use } from "react";
import { Button } from "../Button/Button";
import { DialogContext } from "./contexts/DialogContext";

export function DialogClose({
  asChild = false,
  children,
  onClick,
  ...props
}: {
  asChild?: boolean;
} & ComponentPropsWithRef<typeof Button>) {
  const Component = asChild ? Slot : Button;
  const { onOpenChange } = use(DialogContext);

  const handleClick: MouseEventHandler = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent> &
      React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    onClick?.(e);
    onOpenChange?.(false);
  };

  return (
    <Component onClick={handleClick} {...props}>
      {children}
    </Component>
  );
}
